import React from "react";
import {useSelector} from "react-redux";
import {hasAnyAuthSelector} from "../selectors/authSelectors";

export const HasAnyAuth = ({children}) => {
    const hasAuth = useSelector(hasAnyAuthSelector);
    return hasAuth ? (<>{children}</>) : null;
};
